import { useVehicleCalculate } from "../../../../common/api/queries";
import { createCalcResultsContext } from "../contexts/calcResultsContext";
import { VehicleCalc, VehicleCalcResultData, VehicleCalcType } from "./types";

export const { Provider: VehicleCalcResultsProvider, useCalcResults: useVehicleCalcResults } = createCalcResultsContext<
  VehicleCalc,
  VehicleCalcResultData,
  VehicleCalcType
>(useVehicleCalculate);
